import React from "react";

function Home() {
    window.location.href = '/dashboard/'

    return (<></>);
}

export default Home;